"use strict";
import { formatUnits } from "viem";
export const SECONDS_PER_YEAR = 31536e3;
export const MIN_STAKED_TVL_USD = 100;
export const CL_APR_REFERENCE_DEPOSIT_USD = 100;
export const VOLATILE_PRESET_SPREAD_PERCENT = 3;
export const STABLE_PRESET_SPREAD_PERCENT = 0.1;
export const ONE_TICK_PRESET_SPREAD_PERCENT = 0.05;
export function isPositionInRange(currentTick, tickLower, tickUpper) {
  return currentTick >= tickLower && currentTick < tickUpper;
}
export function getTicksForSpread(currentTick, spreadPercent, tickSpacing) {
  const ticksFromCenter = Math.floor(Math.log(1 + spreadPercent / 100) / Math.log(1.0001));
  const tickLower = Math.floor((currentTick - ticksFromCenter) / tickSpacing) * tickSpacing;
  const tickUpper = Math.ceil((currentTick + ticksFromCenter) / tickSpacing) * tickSpacing;
  if (tickUpper <= tickLower) {
    return {
      tickLower: Math.floor(currentTick / tickSpacing) * tickSpacing,
      tickUpper: Math.floor(currentTick / tickSpacing) * tickSpacing + tickSpacing
    };
  }
  return { tickLower, tickUpper };
}
export function getMaxAprTickBounds(currentTick, tickSpacing) {
  const tickLower = Math.floor(currentTick / tickSpacing) * tickSpacing;
  const tickUpper = tickLower + tickSpacing;
  return { tickLower, tickUpper };
}
export function calculatePositionValueUsd(amounts, prices) {
  const value0Usd = Number(formatUnits(amounts.amount0, prices.token0Decimals)) * prices.token0PriceUsd;
  const value1Usd = Number(formatUnits(amounts.amount1, prices.token1Decimals)) * prices.token1PriceUsd;
  return value0Usd + value1Usd;
}
export function calculateAprPercent(params) {
  const { positionLiquidity, stakedLiquidity, rewardRatePerSecond, rewardTokenPriceUsd, positionValueUsd } = params;
  if (stakedLiquidity === 0n) {
    return Infinity;
  }
  if (positionLiquidity === 0n || positionValueUsd <= 0 || rewardRatePerSecond <= 0 || rewardTokenPriceUsd <= 0) {
    return void 0;
  }
  const liquidityRatio = Number(positionLiquidity) / Number(stakedLiquidity);
  const annualRewardsUsd = liquidityRatio * rewardRatePerSecond * SECONDS_PER_YEAR * rewardTokenPriceUsd;
  const apr = annualRewardsUsd / positionValueUsd * 100;
  if (!Number.isFinite(apr) || apr < 0) {
    return void 0;
  }
  return apr;
}
export function calculateAnnualRewardsUsd(params) {
  const { positionLiquidity, stakedLiquidity, rewardRatePerSecond, rewardTokenPriceUsd } = params;
  if (stakedLiquidity === 0n || positionLiquidity === 0n) {
    return 0;
  }
  const liquidityRatio = Number(positionLiquidity) / Number(stakedLiquidity);
  return liquidityRatio * rewardRatePerSecond * SECONDS_PER_YEAR * rewardTokenPriceUsd;
}
export function isRewardPeriodActive(periodFinish, currentTimestamp) {
  const now = currentTimestamp ?? Math.floor(Date.now() / 1e3);
  return periodFinish === 0 || periodFinish > now;
}
export function parseRewardRate(rewardRateWei, decimals = 18) {
  return Number(formatUnits(rewardRateWei, decimals));
}
export function isStablePair(token0Symbol, token1Symbol) {
  const stableSymbols = /* @__PURE__ */ new Set(["USDC", "USDC.E", "USDT", "DAI", "USDP", "FRAX", "USDE", "USD+", "LUSD", "BUSD"]);
  const symbol0 = token0Symbol?.toUpperCase() ?? "";
  const symbol1 = token1Symbol?.toUpperCase() ?? "";
  return stableSymbols.has(symbol0) && stableSymbols.has(symbol1);
}
export function getPresetSpreadPercent(token0Symbol, token1Symbol, tickSpacing) {
  if (tickSpacing === 1) {
    return ONE_TICK_PRESET_SPREAD_PERCENT;
  }
  return isStablePair(token0Symbol, token1Symbol) ? STABLE_PRESET_SPREAD_PERCENT : VOLATILE_PRESET_SPREAD_PERCENT;
}
